import React from 'react'
import PropTypes from 'prop-types'

export default function Repeat({ times, children }) {
  const repeatCount = times > 0 ? times : 1

  return [...Array(repeatCount)].map((x, idx) => (
    <React.Fragment key={idx}>{React.Children.map(children, React.cloneElement)}</React.Fragment>
  ))
}

Repeat.propTypes = {
  times: PropTypes.number,
}
